import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showMainHeader, showFooter } from 'store/actions/util-actions';
import { sendApplicationLinkWithToken, SEND_APPLICATION_LINK_SUCCESS } from 'store/actions/customer-actions';
import { logBusiness } from 'store/actions/log-actions';

import UrlHelper from 'utils/helper/url-helper';
import { setEventOnDataLayer } from 'utils/helper/datalayer-events-helper';

import history from 'navigation/history';
import routes from 'resources/routes.json';

import styles from './styles.module.scss';

export default function CustomerLogin() {
  const dispatch = useDispatch();
  const showHeader = useSelector((state) => state?.utilReducer?.showMainHeader);

  const [loading, setLoading] = useState(true);
  const [messageKind, setMessageKind] = useState('0');
  const [maskedRecipient, setMaskedRecipient] = useState(null);
  const [error, setError] = useState(false);

  const formFieldsStorage = sessionStorage?.getItem('LEAD_FORM_FIELDS')
    ? JSON.parse(sessionStorage?.getItem('LEAD_FORM_FIELDS'))
    : {};

  const [countdown, setCountdown] = useState(formFieldsStorage?.countdown ? formFieldsStorage?.countdown : null);

  const formFields = {
    emailAddress: UrlHelper.checkIfUrlParamsIsBase64(formFieldsStorage?.emailAddress),
    phoneNumber: UrlHelper.checkIfUrlParamsIsBase64(formFieldsStorage?.mobilePhoneNumber),
    taxId: UrlHelper.checkIfUrlParamsIsBase64(formFieldsStorage?.taxId),
  };

  const IS_EMAIL_MESSAGE_KIND = messageKind === '0';

  useEffect(() => {
    if (showHeader) {
      dispatch(showMainHeader(false));
      dispatch(showFooter(false));
    }
  }, [showHeader]);

  useEffect(() => {
    if (!formFieldsStorage?.emailAddress || !formFieldsStorage?.mobilePhoneNumber || !formFieldsStorage?.taxId) {
      return history.push(routes.LOAN_APPLICATION_START.DEFAULT);
    }

    sendLink();
  }, [messageKind]);

  useEffect(() => {
    if (countdown) {
      setTimeout(() => {
        setCountdown(countdown - 1);
        sessionStorage.setItem('LEAD_FORM_FIELDS', JSON.stringify({ ...formFieldsStorage, countdown }));
      }, 1000);
    } else {
      setCountdown(null);
      sessionStorage.setItem('LEAD_FORM_FIELDS', JSON.stringify({ ...formFieldsStorage, countdown: null }));
    }
  }, [countdown]);

  function sendLink() {
    setLoading(true);
    setError(false);

    const source = UrlHelper?.getQueryParam('utm_source') || '';
    const campaign = UrlHelper?.getQueryParam('utm_campaign') || '';
    const medium = UrlHelper?.getQueryParam('utm_medium') || '';
    const content = UrlHelper?.getQueryParam('utm_content') || '';

    dispatch(
      sendApplicationLinkWithToken(
        messageKind,
        {
          emailAddress: formFields?.emailAddress,
          phoneNumber: formFields?.phoneNumber,
          taxId: formFields?.taxId,
        },
        source,
        campaign,
        medium,
        content,
      ),
    ).then((response) => {
      if (response.type === SEND_APPLICATION_LINK_SUCCESS) {
        setMaskedRecipient(response?.payload?.recipient);
        setEventOnDataLayer(IS_EMAIL_MESSAGE_KIND ? 'login_envioLinkEmail' : 'login_envioLinkSMS');
      } else {
        setError(true);
      }

      setLoading(false);
    });
  }

  function updateMessageKind() {
    setMessageKind(IS_EMAIL_MESSAGE_KIND ? '1' : '0');
  }

  if (loading) {
    return (
      <div className={`${styles.loadingContainer} center`}>
        <span className={styles.loader} />
      </div>
    );
  }

  return (
    <>
      <div className={styles.header}>
        <div
          onClick={() => {
            window.parent.location.href = `/emprestimo/solicitacao/inicio`;
          }}
          style={{ cursor: 'pointer' }}
        >
          <img src="/image/logo.png" width="120" alt="Logo da SuperSim" />
        </div>
      </div>

      <div className={styles.loginContainer}>
        <div>
          {error ? (
            <>
              <img src="/image/error-icon.svg" width="90" alt="Icone de erro" />
              <p className={styles.title}>Houve um problema ao enviar o link de acesso, tente novamente.</p>
            </>
          ) : (
            <>
              {/* <img src="/image/check-cicle-icon.png" alt="Icone de envio de link" /> */}

              {IS_EMAIL_MESSAGE_KIND ? (
                <img src="/image/email-icon.png" alt="Link por email" />
              ) : (
                <img src="/image/sms-icon.png" alt="Link por sms" />
              )}

              <p className={styles.title}>Você recebeu agora a chave (link) de entrada.</p>

              <p className={styles.description}>
                {IS_EMAIL_MESSAGE_KIND
                  ? ' Enviamos um e-mail com um link de acesso. Clique no link para continuar (verifique a caixa de entrada e span).'
                  : 'Enviamos um SMS para seu celular com um link de acesso. Clique no link para continuar.'}
              </p>

              <p className={styles.sentTo}>
                Enviado para: <br />
                <b>{maskedRecipient}</b>
              </p>
            </>
          )}
        </div>

        <div>
          {countdown === null ? (
            <>
              <button
                className={styles.resendButton}
                onClick={() => {
                  sendLink();
                  setCountdown(30);
                }}
              >
                Enviar novamente
              </button>

              <button
                className={styles.changeButton}
                onClick={() => {
                  updateMessageKind();
                  setCountdown(30);
                }}
              >
                {IS_EMAIL_MESSAGE_KIND ? 'Receber acesso por SMS' : 'Receber acesso por e-mail'}
              </button>
            </>
          ) : (
            <button className={styles.changeButton} disabled>
              {`Enviar novamente em ${countdown} s`}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
